var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ServerSideResult',{attrs:{"test":_vm.creditLimits}},[(_vm.signTerms)?_c('Terms',{on:{"termsAccepted":function($event){return _vm.termsAccepted()}},model:{value:(_vm.creditLimits),callback:function ($$v) {_vm.creditLimits=$$v},expression:"creditLimits"}}):_c('Purchases',{attrs:{"balances":_vm.creditLimits}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }